export default __webpack_public_path__ + "fonts/jersey_M54.ttf";